module.exports = __webpack_public_path__ + "static/a2-3494c261d77fc4fd3a82416935d2ee84.png";